import {
    Paper,
    Tabs,
    Text,
    Title,
  } from "@mantine/core";
import { useNavigate, useParams } from "react-router-dom";

export interface TabInterface {
    currentTab: String,
    clientName: String
}

function ClientTabs ({currentTab, clientName}: TabInterface) :JSX.Element {
    const navigate = useNavigate();
    const {resourceType, clientId } = useParams()

    /**
   * Handles a tab change event.
   * @param tabname - The new tab name.
   */
    const onTabChange = (tabname: string) => {
      navigate(`/client/${tabname}/${resourceType}/${clientId}`)
    }

    const tabs = ["Details", "Edit", "JSON"];

    return (
      <Paper
        sx={{
          marginTop: "20px",
          borderRadius: "8px",
          marginLeft: "40px",
          marginRight: "40px",
          padding: "20px",
          background: "'#FFF",
          boxShadow: "0px 1px 24px 2px rgba(0, 0, 0, 0.06)",
        }}
        shadow="sm"
      >
        <Text
          sx={{
            fontWeight: 700,
            fontSize: "26px",
            lineHeight: "36px",
            color: "#262930",
            wordBreak: "break-all",
            overflowWrap: "break-word",
          }}
        >
          {clientName}
        </Text>
        <Tabs value={currentTab.toLowerCase()} onTabChange={onTabChange}>
          <Tabs.List
            style={{
              whiteSpace: "nowrap",
              flexWrap: "nowrap",
              width: "fit-content",
              padding: "0px",
              marginTop: "20px",
            }}
          >
            {tabs.map((t) => (
              <Tabs.Tab
                key={t}
                value={t.toLowerCase()}
                sx={{
                  color:
                    currentTab.toLowerCase() === t.toLowerCase()
                      ? "#1B75BC"
                      : "#99A0AD",
                  fontFamily: "Montserrat",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight:
                    currentTab.toLowerCase() === t.toLowerCase() ? 700 : 500,
                  lineHeight: "22px",
                  paddingLeft: "0px",
                  paddingRight: "0px",
                  marginLeft: "0px",
                  marginRight: "30px",
                }}
              >
                {t}
              </Tabs.Tab>
            ))}
          </Tabs.List>
        </Tabs>
      </Paper>
    );
}

export default ClientTabs;